module.exports = __webpack_public_path__ + "media/10.345a6eb5.mp3";